import { render, staticRenderFns } from "./relogin.vue?vue&type=template&id=550cdb16&scoped=true&"
import script from "./relogin.vue?vue&type=script&lang=js&"
export * from "./relogin.vue?vue&type=script&lang=js&"
import style0 from "./relogin.vue?vue&type=style&index=0&id=550cdb16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550cdb16",
  null
  
)

export default component.exports